import React from 'react';
import PropTypes from 'prop-types';

const Table = ({
  liftLabel,
  typeLabel,
  hoursLabel,
  areaLabel,
  elevationGainLabel,
  timeLabel,
  liftStatuses,
  getIcon
}) => (
  <table className="lift-status-report__table">
    <thead>
      <tr>
        <th></th>
        <th>{liftLabel}</th>
        <th>{typeLabel}</th>
        <th>{hoursLabel}</th>
        <th>{areaLabel}</th>
        <th>{elevationGainLabel}</th>
        <th>{timeLabel}</th>
      </tr>
    </thead>
    <tbody>
      {liftStatuses.map(lift => (
        <tr key={lift.liftName}>
          <td>
            <svg
              className={`lift-status-report__${
                lift.status.toLowerCase() !== 'on hold'
                  ? lift.status.toLowerCase()
                  : 'hold'
              }-icon`}
            >
              <title>list</title>
              <use xlinkHref={getIcon(lift.status)} />
            </svg>
          </td>
          <td>{lift.liftName}</td>
          <td className="lift-status-report__table-value">{lift.type}</td>
          <td className="lift-status-report__table-value">
            {lift.hoursOfOperation}
          </td>
          <td className="lift-status-report__table-value">{lift.area}</td>
          <td className="lift-status-report__table-value">
            {lift.elevationGainFeet} ft./{lift.elevationGainMeters} m
          </td>
          <td className="lift-status-report__table-value">{lift.time}</td>
        </tr>
      ))}
    </tbody>
  </table>
);

Table.propTypes = {
  liftLabel: PropTypes.string.isRequired,
  typeLabel: PropTypes.string.isRequired,
  hoursLabel: PropTypes.string.isRequired,
  areaLabel: PropTypes.string.isRequired,
  elevationGainLabel: PropTypes.string.isRequired,
  timeLabel: PropTypes.string.isRequired,
  liftStatuses: PropTypes.array.isRequired,
  getIcon: PropTypes.func.isRequired
};

export default Table;
